/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as AcceptTermsRouteImport } from './routes/accept-terms'
import { Route as BetaLockedRouteImport } from './routes/beta-locked'
import { Route as PrivateIndexRouteImport } from './routes/_private/index'
import { Route as PrivateAdminRouteImport } from './routes/_private/admin'
import { Route as PrivateAssetsRouteImport } from './routes/_private/assets'
import { Route as PrivateCommissionsRouteImport } from './routes/_private/commissions'
import { Route as PrivateCouponsRouteImport } from './routes/_private/coupons'
import { Route as PrivateDashboardRouteImport } from './routes/_private/dashboard'
import { Route as PrivatePayoutsRouteImport } from './routes/_private/payouts'
import { Route as PrivateReportsRouteImport } from './routes/_private/reports'
import { Route as PrivateSettingsRouteImport } from './routes/_private/settings'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as PrivateAdminIndexRouteImport } from './routes/_private/admin/index'
import { Route as PrivateAdminAccessRouteImport } from './routes/_private/admin/access'
import { Route as PrivateAdminAssetsRouteImport } from './routes/_private/admin/assets'
import { Route as PrivateAdminDashboardRouteImport } from './routes/_private/admin/dashboard'
import { Route as PrivateAdminLedgerRouteImport } from './routes/_private/admin/ledger'
import { Route as PrivateAdminOrdersRouteImport } from './routes/_private/admin/orders'
import { Route as PrivateAdminPartnersRouteImport } from './routes/_private/admin/partners'
import { Route as PrivateAdminPayoutsRouteImport } from './routes/_private/admin/payouts'
import { Route as PrivateAdminReportsRouteImport } from './routes/_private/admin/reports'
import { Route as PrivateAdminSettlementsRouteImport } from './routes/_private/admin/settlements'
import { Route as PrivateAdminTiersRouteImport } from './routes/_private/admin/tiers'
import { Route as AuthLoginOauthIndexRouteImport } from './routes/_auth/login/oauth/index'
import { Route as PrivateAdminPartnersPartnerIdRouteImport } from './routes/_private/admin/partners_.$partnerId'
import { Route as PrivateAdminSettlementsSettlementIdRouteImport } from './routes/_private/admin/settlements_.$settlementId'
import { Route as PrivateAdminSettlementsNewRouteImport } from './routes/_private/admin/settlements_.new'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptTermsRoute = AcceptTermsRouteImport.update({
  id: '/accept-terms',
  path: '/accept-terms',
  getParentRoute: () => rootRouteImport,
} as any)
const BetaLockedRoute = BetaLockedRouteImport.update({
  id: '/beta-locked',
  path: '/beta-locked',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateIndexRoute = PrivateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateAdminRoute = PrivateAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateAssetsRoute = PrivateAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateCommissionsRoute = PrivateCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateCouponsRoute = PrivateCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDashboardRoute = PrivateDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePayoutsRoute = PrivatePayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateReportsRoute = PrivateReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSettingsRoute = PrivateSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PrivateRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any)
const PrivateAdminIndexRoute = PrivateAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminAccessRoute = PrivateAdminAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminAssetsRoute = PrivateAdminAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminDashboardRoute = PrivateAdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminLedgerRoute = PrivateAdminLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminOrdersRoute = PrivateAdminOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminPartnersRoute = PrivateAdminPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminPayoutsRoute = PrivateAdminPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminReportsRoute = PrivateAdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminSettlementsRoute = PrivateAdminSettlementsRouteImport.update({
  id: '/settlements',
  path: '/settlements',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const PrivateAdminTiersRoute = PrivateAdminTiersRouteImport.update({
  id: '/tiers',
  path: '/tiers',
  getParentRoute: () => PrivateAdminRoute,
} as any)
const AuthLoginOauthIndexRoute = AuthLoginOauthIndexRouteImport.update({
  id: '/login/oauth/',
  path: '/login/oauth/',
  getParentRoute: () => AuthRoute,
} as any)
const PrivateAdminPartnersPartnerIdRoute =
  PrivateAdminPartnersPartnerIdRouteImport.update({
    id: '/partners_/$partnerId',
    path: '/partners/$partnerId',
    getParentRoute: () => PrivateAdminRoute,
  } as any)
const PrivateAdminSettlementsSettlementIdRoute =
  PrivateAdminSettlementsSettlementIdRouteImport.update({
    id: '/settlements_/$settlementId',
    path: '/settlements/$settlementId',
    getParentRoute: () => PrivateAdminRoute,
  } as any)
const PrivateAdminSettlementsNewRoute =
  PrivateAdminSettlementsNewRouteImport.update({
    id: '/settlements_/new',
    path: '/settlements/new',
    getParentRoute: () => PrivateAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PrivateIndexRoute
  '/accept-terms': typeof AcceptTermsRoute
  '/beta-locked': typeof BetaLockedRoute
  '/admin': typeof PrivateAdminRouteWithChildren
  '/assets': typeof PrivateAssetsRoute
  '/commissions': typeof PrivateCommissionsRoute
  '/coupons': typeof PrivateCouponsRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/payouts': typeof PrivatePayoutsRoute
  '/reports': typeof PrivateReportsRoute
  '/settings': typeof PrivateSettingsRoute
  '/admin/access': typeof PrivateAdminAccessRoute
  '/admin/assets': typeof PrivateAdminAssetsRoute
  '/admin/dashboard': typeof PrivateAdminDashboardRoute
  '/admin/ledger': typeof PrivateAdminLedgerRoute
  '/admin/orders': typeof PrivateAdminOrdersRoute
  '/admin/partners': typeof PrivateAdminPartnersRoute
  '/admin/payouts': typeof PrivateAdminPayoutsRoute
  '/admin/reports': typeof PrivateAdminReportsRoute
  '/admin/settlements': typeof PrivateAdminSettlementsRoute
  '/admin/tiers': typeof PrivateAdminTiersRoute
  '/login/': typeof AuthLoginIndexRoute
  '/admin/': typeof PrivateAdminIndexRoute
  '/admin/partners/$partnerId': typeof PrivateAdminPartnersPartnerIdRoute
  '/admin/settlements/$settlementId': typeof PrivateAdminSettlementsSettlementIdRoute
  '/admin/settlements/new': typeof PrivateAdminSettlementsNewRoute
  '/login/oauth/': typeof AuthLoginOauthIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PrivateIndexRoute
  '/accept-terms': typeof AcceptTermsRoute
  '/beta-locked': typeof BetaLockedRoute
  '/assets': typeof PrivateAssetsRoute
  '/commissions': typeof PrivateCommissionsRoute
  '/coupons': typeof PrivateCouponsRoute
  '/dashboard': typeof PrivateDashboardRoute
  '/payouts': typeof PrivatePayoutsRoute
  '/reports': typeof PrivateReportsRoute
  '/settings': typeof PrivateSettingsRoute
  '/admin/access': typeof PrivateAdminAccessRoute
  '/admin/assets': typeof PrivateAdminAssetsRoute
  '/admin/dashboard': typeof PrivateAdminDashboardRoute
  '/admin/ledger': typeof PrivateAdminLedgerRoute
  '/admin/orders': typeof PrivateAdminOrdersRoute
  '/admin/partners': typeof PrivateAdminPartnersRoute
  '/admin/payouts': typeof PrivateAdminPayoutsRoute
  '/admin/reports': typeof PrivateAdminReportsRoute
  '/admin/settlements': typeof PrivateAdminSettlementsRoute
  '/admin/tiers': typeof PrivateAdminTiersRoute
  '/login': typeof AuthLoginIndexRoute
  '/admin': typeof PrivateAdminIndexRoute
  '/admin/partners/$partnerId': typeof PrivateAdminPartnersPartnerIdRoute
  '/admin/settlements/$settlementId': typeof PrivateAdminSettlementsSettlementIdRoute
  '/admin/settlements/new': typeof PrivateAdminSettlementsNewRoute
  '/login/oauth': typeof AuthLoginOauthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_private': typeof PrivateRouteWithChildren
  '/accept-terms': typeof AcceptTermsRoute
  '/beta-locked': typeof BetaLockedRoute
  '/_private/admin': typeof PrivateAdminRouteWithChildren
  '/_private/assets': typeof PrivateAssetsRoute
  '/_private/commissions': typeof PrivateCommissionsRoute
  '/_private/coupons': typeof PrivateCouponsRoute
  '/_private/dashboard': typeof PrivateDashboardRoute
  '/_private/payouts': typeof PrivatePayoutsRoute
  '/_private/reports': typeof PrivateReportsRoute
  '/_private/settings': typeof PrivateSettingsRoute
  '/_private/': typeof PrivateIndexRoute
  '/_private/admin/access': typeof PrivateAdminAccessRoute
  '/_private/admin/assets': typeof PrivateAdminAssetsRoute
  '/_private/admin/dashboard': typeof PrivateAdminDashboardRoute
  '/_private/admin/ledger': typeof PrivateAdminLedgerRoute
  '/_private/admin/orders': typeof PrivateAdminOrdersRoute
  '/_private/admin/partners': typeof PrivateAdminPartnersRoute
  '/_private/admin/payouts': typeof PrivateAdminPayoutsRoute
  '/_private/admin/reports': typeof PrivateAdminReportsRoute
  '/_private/admin/settlements': typeof PrivateAdminSettlementsRoute
  '/_private/admin/tiers': typeof PrivateAdminTiersRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_private/admin/': typeof PrivateAdminIndexRoute
  '/_private/admin/partners_/$partnerId': typeof PrivateAdminPartnersPartnerIdRoute
  '/_private/admin/settlements_/$settlementId': typeof PrivateAdminSettlementsSettlementIdRoute
  '/_private/admin/settlements_/new': typeof PrivateAdminSettlementsNewRoute
  '/_auth/login/oauth/': typeof AuthLoginOauthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-terms'
    | '/beta-locked'
    | '/admin'
    | '/assets'
    | '/commissions'
    | '/coupons'
    | '/dashboard'
    | '/payouts'
    | '/reports'
    | '/settings'
    | '/admin/access'
    | '/admin/assets'
    | '/admin/dashboard'
    | '/admin/ledger'
    | '/admin/orders'
    | '/admin/partners'
    | '/admin/payouts'
    | '/admin/reports'
    | '/admin/settlements'
    | '/admin/tiers'
    | '/login/'
    | '/admin/'
    | '/admin/partners/$partnerId'
    | '/admin/settlements/$settlementId'
    | '/admin/settlements/new'
    | '/login/oauth/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-terms'
    | '/beta-locked'
    | '/assets'
    | '/commissions'
    | '/coupons'
    | '/dashboard'
    | '/payouts'
    | '/reports'
    | '/settings'
    | '/admin/access'
    | '/admin/assets'
    | '/admin/dashboard'
    | '/admin/ledger'
    | '/admin/orders'
    | '/admin/partners'
    | '/admin/payouts'
    | '/admin/reports'
    | '/admin/settlements'
    | '/admin/tiers'
    | '/login'
    | '/admin'
    | '/admin/partners/$partnerId'
    | '/admin/settlements/$settlementId'
    | '/admin/settlements/new'
    | '/login/oauth'
  id:
    | '__root__'
    | '/_auth'
    | '/_private'
    | '/accept-terms'
    | '/beta-locked'
    | '/_private/admin'
    | '/_private/assets'
    | '/_private/commissions'
    | '/_private/coupons'
    | '/_private/dashboard'
    | '/_private/payouts'
    | '/_private/reports'
    | '/_private/settings'
    | '/_private/'
    | '/_private/admin/access'
    | '/_private/admin/assets'
    | '/_private/admin/dashboard'
    | '/_private/admin/ledger'
    | '/_private/admin/orders'
    | '/_private/admin/partners'
    | '/_private/admin/payouts'
    | '/_private/admin/reports'
    | '/_private/admin/settlements'
    | '/_private/admin/tiers'
    | '/_auth/login/'
    | '/_private/admin/'
    | '/_private/admin/partners_/$partnerId'
    | '/_private/admin/settlements_/$settlementId'
    | '/_private/admin/settlements_/new'
    | '/_auth/login/oauth/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PrivateRoute: typeof PrivateRouteWithChildren
  AcceptTermsRoute: typeof AcceptTermsRoute
  BetaLockedRoute: typeof BetaLockedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-terms': {
      id: '/accept-terms'
      path: '/accept-terms'
      fullPath: '/accept-terms'
      preLoaderRoute: typeof AcceptTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beta-locked': {
      id: '/beta-locked'
      path: '/beta-locked'
      fullPath: '/beta-locked'
      preLoaderRoute: typeof BetaLockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/': {
      id: '/_private/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivateIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/admin': {
      id: '/_private/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof PrivateAdminRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/assets': {
      id: '/_private/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof PrivateAssetsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/commissions': {
      id: '/_private/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof PrivateCommissionsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/coupons': {
      id: '/_private/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof PrivateCouponsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboard': {
      id: '/_private/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/payouts': {
      id: '/_private/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PrivatePayoutsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/reports': {
      id: '/_private/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof PrivateReportsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/settings': {
      id: '/_private/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_private/admin/': {
      id: '/_private/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof PrivateAdminIndexRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/access': {
      id: '/_private/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof PrivateAdminAccessRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/assets': {
      id: '/_private/admin/assets'
      path: '/assets'
      fullPath: '/admin/assets'
      preLoaderRoute: typeof PrivateAdminAssetsRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/dashboard': {
      id: '/_private/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof PrivateAdminDashboardRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/ledger': {
      id: '/_private/admin/ledger'
      path: '/ledger'
      fullPath: '/admin/ledger'
      preLoaderRoute: typeof PrivateAdminLedgerRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/orders': {
      id: '/_private/admin/orders'
      path: '/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof PrivateAdminOrdersRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/partners': {
      id: '/_private/admin/partners'
      path: '/partners'
      fullPath: '/admin/partners'
      preLoaderRoute: typeof PrivateAdminPartnersRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/payouts': {
      id: '/_private/admin/payouts'
      path: '/payouts'
      fullPath: '/admin/payouts'
      preLoaderRoute: typeof PrivateAdminPayoutsRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/reports': {
      id: '/_private/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof PrivateAdminReportsRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/settlements': {
      id: '/_private/admin/settlements'
      path: '/settlements'
      fullPath: '/admin/settlements'
      preLoaderRoute: typeof PrivateAdminSettlementsRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/tiers': {
      id: '/_private/admin/tiers'
      path: '/tiers'
      fullPath: '/admin/tiers'
      preLoaderRoute: typeof PrivateAdminTiersRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_auth/login/oauth/': {
      id: '/_auth/login/oauth/'
      path: '/login/oauth'
      fullPath: '/login/oauth/'
      preLoaderRoute: typeof AuthLoginOauthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_private/admin/partners_/$partnerId': {
      id: '/_private/admin/partners_/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/admin/partners/$partnerId'
      preLoaderRoute: typeof PrivateAdminPartnersPartnerIdRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/settlements_/$settlementId': {
      id: '/_private/admin/settlements_/$settlementId'
      path: '/settlements/$settlementId'
      fullPath: '/admin/settlements/$settlementId'
      preLoaderRoute: typeof PrivateAdminSettlementsSettlementIdRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
    '/_private/admin/settlements_/new': {
      id: '/_private/admin/settlements_/new'
      path: '/settlements/new'
      fullPath: '/admin/settlements/new'
      preLoaderRoute: typeof PrivateAdminSettlementsNewRouteImport
      parentRoute: typeof PrivateAdminRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthLoginOauthIndexRoute: typeof AuthLoginOauthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthLoginOauthIndexRoute: AuthLoginOauthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PrivateAdminRouteChildren {
  PrivateAdminAccessRoute: typeof PrivateAdminAccessRoute
  PrivateAdminAssetsRoute: typeof PrivateAdminAssetsRoute
  PrivateAdminDashboardRoute: typeof PrivateAdminDashboardRoute
  PrivateAdminLedgerRoute: typeof PrivateAdminLedgerRoute
  PrivateAdminOrdersRoute: typeof PrivateAdminOrdersRoute
  PrivateAdminPartnersRoute: typeof PrivateAdminPartnersRoute
  PrivateAdminPayoutsRoute: typeof PrivateAdminPayoutsRoute
  PrivateAdminReportsRoute: typeof PrivateAdminReportsRoute
  PrivateAdminSettlementsRoute: typeof PrivateAdminSettlementsRoute
  PrivateAdminTiersRoute: typeof PrivateAdminTiersRoute
  PrivateAdminIndexRoute: typeof PrivateAdminIndexRoute
  PrivateAdminPartnersPartnerIdRoute: typeof PrivateAdminPartnersPartnerIdRoute
  PrivateAdminSettlementsSettlementIdRoute: typeof PrivateAdminSettlementsSettlementIdRoute
  PrivateAdminSettlementsNewRoute: typeof PrivateAdminSettlementsNewRoute
}

const PrivateAdminRouteChildren: PrivateAdminRouteChildren = {
  PrivateAdminAccessRoute: PrivateAdminAccessRoute,
  PrivateAdminAssetsRoute: PrivateAdminAssetsRoute,
  PrivateAdminDashboardRoute: PrivateAdminDashboardRoute,
  PrivateAdminLedgerRoute: PrivateAdminLedgerRoute,
  PrivateAdminOrdersRoute: PrivateAdminOrdersRoute,
  PrivateAdminPartnersRoute: PrivateAdminPartnersRoute,
  PrivateAdminPayoutsRoute: PrivateAdminPayoutsRoute,
  PrivateAdminReportsRoute: PrivateAdminReportsRoute,
  PrivateAdminSettlementsRoute: PrivateAdminSettlementsRoute,
  PrivateAdminTiersRoute: PrivateAdminTiersRoute,
  PrivateAdminIndexRoute: PrivateAdminIndexRoute,
  PrivateAdminPartnersPartnerIdRoute: PrivateAdminPartnersPartnerIdRoute,
  PrivateAdminSettlementsSettlementIdRoute:
    PrivateAdminSettlementsSettlementIdRoute,
  PrivateAdminSettlementsNewRoute: PrivateAdminSettlementsNewRoute,
}

const PrivateAdminRouteWithChildren = PrivateAdminRoute._addFileChildren(
  PrivateAdminRouteChildren,
)

interface PrivateRouteChildren {
  PrivateAdminRoute: typeof PrivateAdminRouteWithChildren
  PrivateAssetsRoute: typeof PrivateAssetsRoute
  PrivateCommissionsRoute: typeof PrivateCommissionsRoute
  PrivateCouponsRoute: typeof PrivateCouponsRoute
  PrivateDashboardRoute: typeof PrivateDashboardRoute
  PrivatePayoutsRoute: typeof PrivatePayoutsRoute
  PrivateReportsRoute: typeof PrivateReportsRoute
  PrivateSettingsRoute: typeof PrivateSettingsRoute
  PrivateIndexRoute: typeof PrivateIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateAdminRoute: PrivateAdminRouteWithChildren,
  PrivateAssetsRoute: PrivateAssetsRoute,
  PrivateCommissionsRoute: PrivateCommissionsRoute,
  PrivateCouponsRoute: PrivateCouponsRoute,
  PrivateDashboardRoute: PrivateDashboardRoute,
  PrivatePayoutsRoute: PrivatePayoutsRoute,
  PrivateReportsRoute: PrivateReportsRoute,
  PrivateSettingsRoute: PrivateSettingsRoute,
  PrivateIndexRoute: PrivateIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PrivateRoute: PrivateRouteWithChildren,
  AcceptTermsRoute: AcceptTermsRoute,
  BetaLockedRoute: BetaLockedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
